import './SearchResults.scss';
import * as React from 'react';
import SearchResult from 'components/docs/SearchResult';
import { DocPage } from 'types/docs';
type Props = {
  rawQuery: string;
  results: Array<DocPage>;
  selectedResultIndex: number | undefined | null;
  onSelectResult: () => void;
  error: null | 'short-query' | 'no-results';
};
export default class SearchResults extends React.Component<Props> {
  render() {
    const { rawQuery, results, selectedResultIndex, error } = this.props;
    return (
      <div className="docs-SearchResults">
        {error != null && (
          <div className="docs-SearchResults-error">
            {error === 'short-query'
              ? 'Enter at least three characters to search'
              : `No results for "${rawQuery}"`}
          </div>
        )}

        {results.map((result, i) => (
          <SearchResult
            selected={i === selectedResultIndex}
            key={result.path}
            result={result}
            rawQuery={rawQuery}
            onSelectResult={this.props.onSelectResult}
          />
        ))}
      </div>
    );
  }
}
